import DataService from "../../DataService";

const getFranchiseList = async ({ limit, offset }) => {
  let url = `admin/franchise/`;
  if (limit && offset) {
    url += `?limit=${limit}&offset=${offset}`;
  }
  const data = await DataService.get(url);
  return data.data;
};

const getFranchiseDetails = async (id) => {
  let url = `admin/franchise/${id}/`;
  const data = await DataService.get(url);
  return data.data;
};

const addFranchise = async (value) => {
  let url = `admin/franchise/`;
  const data = await DataService.post(url, value);
  return data;
};

const updateFranchise = async (value) => {
  const { id, ...editData } = value;
  const url = `admin/franchise/${id}/`;
  const response = await DataService.patch(url, value);
  return response;
};

const getCurrentFranchise = async () => {
  let url = `/admin/franchise/my-franchise/`;
  const data = await DataService.get(url);
  return data.data;
};

const getFranchiseWalletOrdersList = async ({ limit, offset, franchise }) => {
  let url = `admin/franchise/add-to-wallet/order/create/?limit=${limit}&offset=${offset}`;
  if (franchise) {
    url += `&franchise=${franchise}`;
  }
  const data = await DataService.get(url);
  return data.data;
};

const getFranchiseWalletTransactionsList = async ({ limit, offset,franchise ,status }) => {
  let url = `admin/franchise/wallet-transactions/?limit=${limit}&offset=${offset}`;
  if (franchise) {
    url += `&franchise=${franchise}`;
  }
  if (status) {
    url += `&status=${status}`;
  }
  const data = await DataService.get(url);
  return data.data;
};

const createWalletTopUp = async (value) => {
  let url = `admin/franchise/admin-wallet-top-up/`;
  const data = await DataService.post(url, value);
  return data;
};

const addWalletOrder = async (value) => {
  let url = `admin/franchise/add-to-wallet/order/create/`;
  const data = await DataService.post(url, value);
  return data;
};

const verifyWalletTransaction = async (value) => {
  let url = `admin/franchise/verify-wallet-transaction/`;
  const data = await DataService.post(url, value);
  return data;
};

const retryWalletTransaction = async (value) => {
  const { id, ...editData } = value;
  let url = `admin/franchise/retry-wallet-transaction/${id}/`;
  const data = await DataService.patch(url, editData);
  return data;
};

export {
  getFranchiseList,
  getFranchiseDetails,
  addFranchise,
  updateFranchise,
  getFranchiseWalletOrdersList,
  getFranchiseWalletTransactionsList,
  addWalletOrder,
  verifyWalletTransaction,
  retryWalletTransaction,
  getCurrentFranchise,
  createWalletTopUp
};
